import { useForm } from "react-hook-form";
import { useContext, useState } from "react";
import useAppNavigate from "../../components/router/use-app-navigate";
import AuthContext from "../../components/auth-context";
import Form from "../../components/inputs/form";
import Submit from "../../components/inputs/submit";
import Textbox from "../../components/inputs/textbox";
import NgnChannelApi from "../../api/ngnChannel";
import PurchaseTicketApi from "../../api/purchase-ticket";

interface NgnForm {
  channelsCount: string;
}

function PurchaseChannel() {
  const context = useContext(AuthContext);
  const { register, handleSubmit } = useForm<NgnForm>();
  const navigate = useAppNavigate();
  const [channelsCount, setChannelsCount] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [isSubmit, setIsSubmit] = useState<boolean>(false);
  const onSubmit: (data: any) => Promise<string> = ({ channelsCount }) => {
    setIsSubmit(true);
    return new NgnChannelApi(context)
      .post(context.activeFileId!)
      .then((response) => {
        if (!response.errorMessage) {
          return new PurchaseTicketApi(context)
            .post(
              context.activeFileId!,
              11,
              8489,
              undefined,
              undefined,
              channelsCount
            )
            .then((ticket) => {
              setIsSubmit(false);
              if (ticket.errorMessage) {
                setError(ticket.errorMessage);
              } else {
                setIsSubmit(true);
                new PurchaseTicketApi(context)
                  .getAll()
                  .then(context.setTickets)
                  .catch(() => {});
                setIsSubmit(false);
                navigate(`/payment/${ticket.id}`);
              }
              return ticket.errorMessage;
            });
        }
      })
      .catch((error) => {
        console.error("NGN Channel API Error:", error);
      });
  };

  return (
    <>
      <Form submit={onSubmit} handleSubmit={handleSubmit}>
        <Textbox
          {...register("channelsCount")}
          label="تعدا کانال"
          type="number"
          onChange={(e) => setChannelsCount(e.target.value)}
          defaultValue={channelsCount}
        />
        <Submit loading={isSubmit} />
      </Form>
      {error && <p style={{ color: "red" }}>{error}</p>}
    </>
  );
}

export default PurchaseChannel;
